import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import Table from "react-bootstrap/Table"
import { Accordion, Container, Col, Row } from "react-bootstrap"
import PageLayout from "../../../components/PageLayout"
import { Search } from "../../../components/Search"

import "bootstrap/dist/css/bootstrap.min.css"

import {
  content,
  programColLeft,
  buttonColRight
} from '../index.module.css'

function filterDepartments(departmentFilter, schoolFilter, nodes) {
    if (!departmentFilter || departmentFilter === '') {
        return nodes.filter((node) => {
            const upperSchool = node.school.toUpperCase()
            return schoolFilter === 'ALL' || upperSchool === schoolFilter
        })
    }

    return nodes.filter((node) => {
        const filter = departmentFilter.toLowerCase()
        const upperSchool = node.school.toUpperCase()
        const lowerDepartmentName = node.departmentName.toLowerCase()
        return lowerDepartmentName.includes(filter) && (upperSchool === schoolFilter || schoolFilter === 'ALL')
    })
}

const IndexPage = ({ data }) => {
    const assessments = data.allDepartmentAssessments20242025.nodes
    const [ departmentFilter, setDepartmentFilter ] = useState('');
    const [ schoolFilter, setSchoolFilter ] = useState('ALL')

    if (assessments) {
        assessments.sort((a1, a2) => {
            const item1 = a1
            const item2 = a2

            if (item1.school > item2.school) return 1
            if (item1.school < item2.school) return -1

            if (item1.departmentName > item2.departmentName) return 1
            if (item1.departmentName < item2.departmentName) return -1;

            return 0
        })
    }

    const filteredDepartments = filterDepartments(departmentFilter, schoolFilter, assessments)
    
    return (
        <PageLayout>
            <div className={content}>
                <main>
                    <div className="pricing-header p-3 pb-md-4 mx-auto text-center">
                        <h1 className="display-4 fw-normal">Assessment Reports</h1>
                        <p className="fs-5 text-muted">
                        Program and General Education Learning Outcomes Assessment
                        </p>
                    </div>

                    <div className="col cp-card-header">
                        <div className="card mb-4 rounded-3 shadow-sm" style={{width: "100%"}}>
                            <div className="card-header py-3">
                                <h4 className="my-0 fw-normal">Assessment Reports for 2024-2025</h4>
                            </div>
                            <div className="card-body">
                                <Search
                                    name={'departmentName'}
                                    onFilterChanged={(e) => setDepartmentFilter(e.target.value)}
                                    onSchoolChanged={(e) => setSchoolFilter(e.target.value)}
                                    fastVersion={2}
                                    />
                                <Accordion>
                                    {filteredDepartments.map((assessment, index) => (
                                        <Accordion.Item eventKey={assessment.departmentId} key={index}>
                                            <Accordion.Header>
                                                <Container>
                                                    <Row>
                                                        <Col sm={1}>{assessment.school}</Col>
                                                        <Col sm={11}>{assessment.departmentName}</Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <Table hover style={{ width: "100% "}}>
                                                    <tbody>
                                                        {assessment.programAssessments.map((programAssessment, index) => (
                                                            <tr key={index}>
                                                                <td className={programColLeft}>
                                                                    {programAssessment.programName}
                                                                </td>
                                                                <td className={buttonColRight}>
                                                                    <Link
                                                                    to={`${programAssessment.assessmentId}`}
                                                                    className="btn btn-outline-primary pull-right"
                                                                    role="button">
                                                                    View
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </PageLayout>
    )
}

export const query = graphql`
  query {
    allDepartmentAssessments20242025 {
        nodes {
            departmentAssessmentId
            departmentId
            departmentName
            dateModified
            school
            programAssessments {
                assessmentId
                programName
                reviewYear
                createdBy
                dateCreated
                modifiedBy
                dateModified
            }
        }
    }
  }
`

export default IndexPage
